<section>
  <div class="header">
    <h2>{{ title }}</h2>

    <ng-content select="[slot='actions']"></ng-content>
  </div>

  <div class="custom-header">
    <ng-content select="[slot='header']"></ng-content>
  </div>

  <ng-content></ng-content>

  <opac-divider *ngIf="divider"></opac-divider>
</section>
